interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Fantom = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_27154)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#1864F2"
      />
      <path
        d="M49.9198 20L32 30.3435V69.6565L49.9198 80L67.8397 69.6565V30.3435L49.9198 20ZM62.4644 31.3804L49.9198 38.6196L37.3753 31.3804L49.9198 24.1412L62.4644 31.3804ZM48.126 56.2087L37.3753 50L48.126 43.7913V56.2087ZM51.7074 43.7913L62.458 50L51.7074 56.2087V43.7913ZM35.5814 34.4784L46.3321 40.687L35.5814 46.8957V34.4784ZM64.2519 67.5827L49.9135 75.8588L35.5751 67.5827V53.098L49.9135 61.374L64.2519 53.098V67.5827ZM53.5013 40.6807L64.2519 34.472V46.8893L53.5013 40.6807Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_27154">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
